// extracted by mini-css-extract-plugin
export default {"tambahPenggunaSection":"style_tambahPenggunaSection__ub8jC","actionsSection":"style_actionsSection__9aexx","formSection":"style_formSection__4wVv6"};